export { default as TableCellProperties } from './tablecellproperties';